const Footer = () => {
  // Get social media URLs from environment variables
  const socialLinks = {
    twitter: import.meta.env.VITE_SOCIAL_TWITTER_URL,
    facebook: import.meta.env.VITE_SOCIAL_FACEBOOK_URL,
    instagram: import.meta.env.VITE_SOCIAL_INSTAGRAM_URL,
  };

  // Check if any social links are configured
  const hasSocialLinks = Object.values(socialLinks).some(url => url);

  return (
    <footer className="bg-urban text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-treasure rounded-full flex items-center justify-center">
                <span className="text-urban font-bold text-sm">🏆</span>
              </div>
              <span className="text-xl font-bold">Curbside Quest</span>
            </div>
            <p className="text-urban-100 max-w-md mb-6">
              Discover treasures in your community while promoting sustainability through item reuse.
            </p>
            
            
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">Community</h3>
            <ul className="space-y-2 text-urban-100">
              {/* <li><a href="#" className="hover:text-treasure">How it Works</a></li> */}
              <li><a href="/guidelines" className="hover:text-treasure">Guidelines</a></li>
              {/* <li><a href="#" className="hover:text-treasure">Safety Tips</a></li> */}
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">Support</h3>
            <ul className="space-y-2 text-urban-100">
              {/* <li><a href="#" className="hover:text-treasure">Help Center</a></li> */}
              <li><a href="#follow-us" className="hover:text-treasure">Contact Us on Socials</a></li>
              {/* <li><a href="#" className="hover:text-treasure">Report Issue</a></li >*/}
            </ul>
          </div>
        </div>
        {/* Social Media Links */}
        {hasSocialLinks && (
              <div id="follow-us">
                <h4 className="font-semibold mb-3 text-sm text-center">Follow Us</h4>

                <div className="flex space-x-4 justify-center">
                  {socialLinks.twitter && (
                    <a
                      href={socialLinks.twitter}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-urban-100 hover:text-treasure transition-colors duration-200"
                      aria-label="Follow us on Twitter/X"
                    >
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                      </svg>
                    </a>
                  )}
                  
                  {socialLinks.facebook && (
                    <a
                      href={socialLinks.facebook}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-urban-100 hover:text-treasure transition-colors duration-200"
                      aria-label="Follow us on Facebook"
                    >
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                      </svg>
                    </a>
                  )}
                  
                  {socialLinks.instagram && (
                    <a
                      href={socialLinks.instagram}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-urban-100 hover:text-treasure transition-colors duration-200"
                      aria-label="Follow us on Instagram"
                    >
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 6.62 5.367 11.987 11.988 11.987 6.62 0 11.987-5.367 11.987-11.987C24.014 5.367 18.637.001 12.017.001zM8.449 16.988c-1.297 0-2.448-.49-3.323-1.297C4.198 14.895 3.708 13.744 3.708 12.447s.49-2.448 1.418-3.323c.875-.807 2.026-1.297 3.323-1.297s2.448.49 3.323 1.297c.928.875 1.418 2.026 1.418 3.323s-.49 2.448-1.418 3.244c-.875.807-2.026 1.297-3.323 1.297zm7.83-9.405c-.315 0-.595-.122-.807-.315-.21-.21-.315-.49-.315-.807 0-.315.105-.595.315-.807.21-.21.49-.315.807-.315.315 0 .595.105.807.315.21.21.315.49.315.807 0 .315-.105.595-.315.807-.21.193-.49.315-.807.315zm-3.832 9.405c-2.5 0-4.532-2.032-4.532-4.532s2.032-4.532 4.532-4.532 4.532 2.032 4.532 4.532-2.032 4.532-4.532 4.532z"/>
                      </svg>
                    </a>
                  )}
                </div>
              </div>
            )}
        <div className="border-t border-urban-800 mt-8 pt-8 text-center text-urban-100">
          <p>&copy; 2025 Curbside Quest. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;